var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0903 11.3057C10.9263 10.4516 9.18187 8.95807 4.18051 8.95807V19.6523C9.18187 19.6523 10.9263 21.1459 12.0903 22M12.0903 11.3057V22M12.0903 11.3057C13.2542 10.4516 14.9986 8.95807 20 8.95807V19.6523C14.9986 19.6523 13.2542 21.1459 12.0903 22M15.1807 2.08341V5.83968M17.9459 2H7.55573C7.26544 1.99965 6.98084 2.0799 6.7341 2.23168L4 3.92138L6.7341 5.608C6.98084 5.75978 7.26544 5.84003 7.55573 5.83968H17.9459C18.2044 5.84696 18.4618 5.80271 18.7028 5.70954C18.9438 5.61637 19.1635 5.47618 19.349 5.29726C19.5344 5.11834 19.6818 4.90432 19.7825 4.66786C19.8832 4.43141 19.935 4.17731 19.935 3.92061C19.935 3.66391 19.8832 3.40982 19.7825 3.17336C19.6818 2.93691 19.5344 2.72289 19.349 2.54397C19.1635 2.36504 18.9438 2.22485 18.7028 2.13169C18.4618 2.03852 18.2044 1.99272 17.9459 2Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApayment);
export default __webpack_public_path__ + "static/media/Apayment.e02a5101d94ea2b2984924c1047691ec.svg";
export { ForwardRef as ReactComponent };